const environment=true;

const config={
liveTechlabUrl:" https://choicetechlab.com/api",
UATTechlabUrl:" https://uat.choicetechlab.com/api",
}

export class API_URLS{
    TechlabUrl="";

constructor(){
    this.setConfig(environment ? "live" : "UAT");
}

setConfig(configKey){
this.setTechLabBaseURL(config[configKey+"TechlabUrl"]);
}

setTechLabBaseURL(url){
this.TechlabUrl=url;
}
//URL For Contact Form
contactForm="/contact/enquiry";

//URL For Quote Form
quoteForm="/quotes/enquiry";

//url for request for demo enquiry
requestForm="/demorequest/enquiry";

//url for newsletter
NewsletterForm="/subscribes/newsletter";
//url for carrer page 
careerForm="/career/jobapplication";
//for get location and dempartments positions
getldp="/career/getldp"
getContactFormURL(){
return this.TechlabUrl+this.contactForm;
}

getQuoteFormUrl(){
return this.TechlabUrl+this.quoteForm;
}
getrequestFormUrl(){
    return this.TechlabUrl+this.requestForm;
    }
getNewsletterForm(){
    return this.TechlabUrl+this.NewsletterForm;
}
getCareerForm(){
    return this.TechlabUrl+this.careerForm;
}
getldpform(){
    return this.TechlabUrl+this.getldp;
}
}
